import Vue from 'vue'
import Router from 'vue-router'
import MainRoutes from './modules/mainRouter'

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/dashboard',
            component: () => import('./common/dashboard')
        },
        ...MainRoutes
    ]
})
